import { z } from 'zod';
import type { GetCourseDto } from '../types/GetCourseDto';

export const getCourseDtoSchema = z.object({
  id: z.string().uuid(),
  title: z.string().min(3).max(255),
  description: z.string().min(3).max(255).nullable(),
  cover: z.string().nullable(),
  isPublic: z.boolean().default(true).optional(),
  isActive: z.boolean().default(false).optional(),
  numberOfCards: z.object({ active: z.number(), inactive: z.number() }),
  cards: z.array(
    z.object({
      id: z.string().uuid(),
      title: z.string().min(3).max(255),
      type: z.enum([
        'video',
        'image',
        'text',
        'textAndImage',
        'quiz',
        'redirect',
      ]),
      isActive: z.boolean().default(false).optional(),
      content: z.string().nullable(),
      contentImage: z.string().nullable(),
      contentDetails: z.string().nullable(),
      position: z.number().int().min(1),
    }),
  ),
}) as z.ZodType<GetCourseDto>;
